import { render } from "./Footer.vue?vue&type=template&id=814d2ba8"
import script from "./Footer.vue?vue&type=script&scoped=true&lang=js"
export * from "./Footer.vue?vue&type=script&scoped=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=814d2ba8&lang=scss"

import exportComponent from "/codebuild/output/src2122201245/src/dapp.nftea.studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__